import React, { useEffect, useState } from "react";
import { firestore } from "../../firebase-config";
import { collection, getDocs } from "firebase/firestore";
import "../../styles/gallery.css";

const Gallery = () => {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    const fetchPhotos = async () => {
      const querySnapshot = await getDocs(collection(firestore, "gallery"));
      const photoList = querySnapshot.docs.map((doc) => doc.data());
      setPhotos(photoList);
    };

    fetchPhotos();
  }, []);

  return (
    <div>
    <div className="gallery-h1">
      <h1>GALLERY</h1></div>
      <div className="gallery-container">
        {photos.length === 0 ? (
          <p>No photos available.</p>
        ) : (
          photos.map((photo, index) => (
            <div
              key={index}
              className="gallery-item"
            >
              <img src={photo.imageUrl} alt={photo.name} />
              <div className="image-details">
                <h3>{photo.name}</h3>
                {photo.date && <p>Date: {photo.date}</p>}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default Gallery;

